export const report_bill_lang={
  TH:{
    status_code: "สถานะการชำระ",
    month_search:"ค้นหารายการใบเสร็จรับเงิน",
    choose_year:"เลือกปี",
    choose_month:"เลือกเดือน",
    choose_type_report:"เลือกแสดงข้อมูล",
    choose_day: "เลือกวัน",
    all_bill:"ใบรับเงินทั้งหมด",
    total_bill:"ยอดรวมทั้งหมด",
    header_table:"ข้อมูลสถานที่ผู้เสียค่าธรรมเนียม",
    search:"ค้นหา",
    place_id: "รหัสที่อยู่",
    place_desc: "ที่อยู่/บ้านเลขที่",
    place_type_desc: "ชนิดที่อยู่",
    customer_name: "ชื่อผู้เสียภาษี",
    place_address: "ที่อยู่",
    fee_type_description: "ประเภทค่าธรรมเนียม",
    back_to_bill:"ย้อนกลับไปยังหน้ารายละเอียดใบเสร็จ",
    fee_type_unit: "รายละเอียดค่าธรรมเนียม",
    show_detail: "แสดงรายละเอียด",
    back: "ย้อนกลับ",
    bill_id: "รหัสใบเสร็จรับเงิน",
    bill_desc: "รายละเอียด",
    bill_date: "วันที่ชำระ",
    bill_user: "ผู้ออกเอกสาร",
    bill_discount: "ส่วนลด",
    bill_total_price: "ยอดชำระ",
    bill_payment_desc: "ประเภทการชำระ",
    print_bill:"พิมพ์ใบเสร็จรับเงิน",
    print_bill_3x4:"พิมพ์ใบเสร็จรับเงินขนาดพกพา",
    report_count: "จำนวนใบเสร็จรับเงิน : ",
    report_price: "ยอดรวมค่าธรรมเนียม : ",
    report_count_cancel: "จำนวนใบเสร็จรับเงินที่ยกเลิก : ",
    show_bill: "แสดงใบเสร็จรับเงิน",
    due_date: "วันที่กำหนดชำระ",
    fee_id: "รหัสค่าธรรมเนียม",
    fee_description: "รายละเอียดค่าธรรมเนียม",
    customer_id: "รหัสลูกค้า",
    user_id: "ผู้ออกใบ",
    request_general_id:"หมายเลขคำร้อง",
    request_alert:"กรุณากรอกหมายเลขคำร้อง",
    cancel_bill:"ยกเลิกใบเสร็จรับเงิน",
    want_delete:"ฉันต้องยกเลิก",
    confirm_delete:"คุณต้องการยกเลิกใบเสร็จรับเงินนี้ใช่หรือไม่?",
    warining_delete:"ข้อมูลที่ยกเลิกแล้วจะไม่สามารถย้อนกลับได้!!",
    close:"ปิดหน้านี้",
    deleted: "ยกเลิกใบเสร็จรับเงิน เรียบร้อยแล้ว",
    invoice_id:"รหัสใบแจ้งหนี้",
    date_start: 'เลือกวันเริ่มต้น/สิ้นสุด',

  },
  EN:{
    status_code: "Status",
    month_search:"search by year/month/day",
    choose_year:"choose_year",
    choose_month:"choose month",
    choose_type_report:"choose type report",
    choose_day: "choose day",
    all_bill:"All Bills",
    total_bill:"Total Bills",
    date_start:'Select start/end date',

    back_to_bill:"back to detail bill",
    search:"Search",
    place_id: "Place ID",
    place_desc: "Place Desc",
    print_bill_3x4:"Pocket size receipt printing",
    place_type_desc: "Place Type",
    customer_name: "Customer Name",
    place_address: "Address",
    fee_type_description: "Fee Description",
    fee_type_unit: "Fee",
    show_detail: "Detail",
    back: "Back",
    bill_id: "Bill Id",
    bill_desc: "Bill Detail",
    bill_date: "Bill Date",
    bill_user: "Issuer",
    print_bill:"Print Bill",
    report_count: "Total Bill : ",
    report_price: "Total Price Bill : ",
    report_count_cancel: "Total Bill (Cancel) : ",
    show_bill: "Show Bill",
    due_date: "Due Date",
    fee_id: "Fee Id",
    fee_description: "Fee Description ",
    customer_id: "Customer Id",
    user_id: "User Id",
    request_general_id:"request general id",
    request_alert:"please input request general id",
    cancel_bill:"Cancel Bill",
    want_delete:"Yes delete it",
    confirm_delete:"Are you sure to delete this bill item?",
    warining_delete:"Deleted data can't recovery!",
    close:"Close",
    deleted: "Cancel bill success",
    invoice_id:"Invoice id",
    bill_total_price: "Amount to be paid",
    bill_payment_desc: "Payment type",

  }
}
